import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const FORMULARIO = {
    FIRMA: "firma",
    FOTOGRAFIA: "fotografia",
    ESTADO_DE_PAGO: "estado_de_pago",
    QUIEN_RECIBE_ENTREGA: "quien_recibe_entrega",
    NOTA: "nota",
    FECHA: "fecha",
    HORA: "hora",
};

export const FORMULARIO_INCIDENTE = {
    FIRMA: "firma",
    FOTOGRAFIA: "fotografia",
    NOTA: "nota",
    FECHA: "fecha",
    HORA: "hora",
};

/** Stable keys persisted in the database — do not change. */
export const FORMULARIO_VIAJE_KEY = {
    NOTA: "input_nota",
    FECHA: "input_fecha",
    HORA: "input_hora",
    SELECCIONE_TRANSPORTADORA: "seleccione_transportadora",
    SELECCIONE_VEHICULO: "seleccione_vehiculo",
    SELECCIONE_ORIGEN: "seleccione_origen",
    SELECCIONE_DESTINO: "seleccione_destino",
    SELECCIONE_GEORUTA: "seleccione_georuta",
    SELECCIONE_PRODUCTO: "seleccione_producto",
    SELECCIONE_TIPO_DE_CARGA: "seleccione_tipo_de_carga",
    SELECCIONE_CHOFER: "seleccione_chofer",
    INPUT_CANTIDAD: "input_cantidad",
};

/** @deprecated Use FORMULARIO_VIAJE_KEY */
// export const FORMULARIO_VIAJE = FORMULARIO_VIAJE_KEY;

const FORMULARIO_VIAJE_DEF = [
    { key: FORMULARIO_VIAJE_KEY.NOTA, labelKey: "label_nota" },
    { key: FORMULARIO_VIAJE_KEY.FECHA, labelKey: "label_fecha" },
    { key: FORMULARIO_VIAJE_KEY.HORA, labelKey: "label_hora" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_TRANSPORTADORA, labelKey: "label_seleccione_transportadora" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_VEHICULO, labelKey: "label_seleccione_vehiculo" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_ORIGEN, labelKey: "label_seleccione_origen" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_DESTINO, labelKey: "label_seleccione_destino" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_GEORUTA, labelKey: "label_seleccione_georuta" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_PRODUCTO, labelKey: "label_seleccione_producto" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_TIPO_DE_CARGA, labelKey: "label_seleccione_tipo_de_carga" },
    { key: FORMULARIO_VIAJE_KEY.SELECCIONE_CHOFER, labelKey: "label_seleccione_chofer" },
    { key: FORMULARIO_VIAJE_KEY.INPUT_CANTIDAD, labelKey: "label_input_cantidad" },
];

/** Returns field types with stable `key`/`value` and translated `label` for UI. */
export const useFormularioViaje = () => {
    const { t, i18n } = useTranslation();

    return useMemo(
        () =>
            FORMULARIO_VIAJE_DEF.map(({ key, labelKey }) => ({
                key,
                value: key,
                label: t(labelKey),
            })),
        [i18n.language]
    );
};

/** Resolve a saved field type key to its translated label. */
export const useFormularioViajeLabelByKey = () => {
    const items = useFormularioViaje();

    return useMemo(() => {
        const byKey = new Map(items.map((item) => [item.key, item.label]));
        return (key) => byKey.get(key) ?? key;
    }, [items]);
};
